module.exports = "/virtual-football/img/video/clubs/germany/schalke04.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football/img/video/clubs/germany/schalke04.png
// module id = 298
// module chunks = 6